import { getTimezoneOffset, toZonedTime } from 'date-fns-tz';
import timezones from '../constants/timezones';
export const timezoneOffsetCalculation = (date, timezoneId) => {
    const dateFormatted = new Date(date);
    if (!dateFormatted || isNaN(dateFormatted.getTime())) {
        throw new Error('Invalid Date');
    }
    const timezoneRows = !timezoneId ? [] : timezones.filter((tz) => tz.value === timezoneId);
    const timezone = timezoneRows.length === 1 ? timezoneRows[0].label : 'UTC';
    const zonedDate = toZonedTime(dateFormatted, timezone);
    const offset = getTimezoneOffset(timezone, zonedDate);
    const offsetInMinutes = -offset / 60000;
    const normalizedOffset = Object.is(offsetInMinutes, -0) ? 0 : offsetInMinutes;
    return normalizedOffset - dateFormatted.getTimezoneOffset();
};
